import { render, staticRenderFns } from "./BIVisualization.vue?vue&type=template&id=60d63da4&scoped=true&"
import script from "./BIVisualization.vue?vue&type=script&lang=js&"
export * from "./BIVisualization.vue?vue&type=script&lang=js&"
import style0 from "./BIVisualization.vue?vue&type=style&index=0&id=60d63da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d63da4",
  null
  
)

export default component.exports